export default __webpack_public_path__ + "static/media/klvb_star.f85dfbfc.svg";